/* eslint-disable */

// Copying errorsHashToArray helper from Ember Data 4.12 private utils code:
// https://github.com/emberjs/data/blob/431c81be783db574a65452696b5774a98e96c071/packages/adapter/src/error.js#L395
//
// Our "application" adapter needs it for custom error handling, but importing
// it directly from Ember Data is now deprecated:
// https://api.emberjs.com/ember-data/4.12/classes/CurrentDeprecations/properties/DEPRECATE_A_USAGE?anchor=DEPRECATE_HELPERS

function makeArray<T>(value: T | T[]): T[] {
  return Array.isArray(value) ? value : [value];
}

const PRIMARY_ATTRIBUTE_KEY = 'base';

export function errorsHashToArray(errors: any) {
  let out: any[] = [];

  if (errors) {
    Object.keys(errors).forEach((key) => {
      let messages = makeArray(errors[key]);
      for (let i = 0; i < messages.length; i++) {
        let title = 'Invalid Attribute';
        let pointer = `/data/attributes/${key}`;
        if (key === PRIMARY_ATTRIBUTE_KEY) {
          title = 'Invalid Document';
          pointer = `/data`;
        }
        out.push({
          title: title,
          detail: messages[i],
          source: {
            pointer: pointer,
          },
        });
      }
    });
  }

  return out;
}
